// src/components/AboutUs.js
import React from 'react';
import { FaGraduationCap, FaChalkboardTeacher, FaUsers, FaCheck, FaGlobe } from 'react-icons/fa';
import { MdTranslate, MdAnalytics, MdTimer, MdGroupWork } from 'react-icons/md';
import SEO from './SEO';

const AboutUs = () => {
  return (
    <div className="container py-5">
      <SEO
        title="About Us - My Exam World | Multilingual Online Exam Portal"
        description="Learn about My Exam World, an online exam platform enabling students to take mock tests and educators to build multilingual test series."
        keywords="about my exam world, online test series platform, education portal, mock exam creator"
        url="/aboutus"
      />
      {/* Hero Section */}
      <section className="text-center mb-5">
        <h1 className="display-4 fw-bold  mb-3" style={{color:"#0096c7"}}>About My Exam World</h1>
        <p className="lead text-muted mb-4">
        Making online exams better for everyone
        </p>
        <div className="d-flex justify-content-center gap-3">
          <span className="badge bg-primary bg-opacity-10 text-primary p-2">Interactive</span>
          <span className="badge bg-success bg-opacity-10 text-success p-2">Multilingual</span>
          <span className="badge bg-info bg-opacity-10 text-info p-2">Analytics</span>
        </div>
      </section>

      {/* Features Grid */}
      <section className="row g-4 mb-5">
        {/* For Students */}
        <div className="col-lg-6">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-header bg-primary bg-opacity-10">
              <h3 className="mb-0 d-flex align-items-center">
                <FaGraduationCap className="me-2 " style={{color:"#0096c7"}} /> For Students
              </h3>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <FeatureItem icon={<FaCheck className="text-success" />} text="Explore a wide variety of test series" />
                <FeatureItem icon={<MdTimer className="text-info" />} text="Participate in live exams with timers" />
                <FeatureItem icon={<MdAnalytics className="text-warning" />} text="Get instant results with detailed analytics" />
                <FeatureItem icon={<MdGroupWork className="text-primary" />} text="Experience real-exam environments" />
                <FeatureItem icon={<FaGlobe className="text-info" />} text="Access exams in 10 different languages" />
                <FeatureItem icon={<FaUsers className="text-secondary" />} text="Subscribe to favorite creators" />
              </ul>
            </div>
          </div>
        </div>

        {/* For Creators */}
        <div className="col-lg-6">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-header bg-success bg-opacity-10">
              <h3 className="mb-0 d-flex align-items-center">
                <FaChalkboardTeacher className="me-2 " style={{color:"#ff7e5f"}} /> For Educators
              </h3>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <FeatureItem icon={<FaCheck className="text-success" />} text="Build exams quickly and intelligently" />
                <FeatureItem icon={<MdTranslate className="text-primary" />} text="Auto-translate content into multiple languages" />
                <FeatureItem icon={<MdTimer className="text-danger" />} text="Save hours on manual translation" />
                <FeatureItem icon={<MdAnalytics className="text-warning" />} text="Track who attempted your tests" />
                <FeatureItem icon={<FaUsers className="text-info" />} text="View options selected by students" />
                <FeatureItem icon={<FaCheck className="text-success" />} text="Improve exams with real insights" />
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Community CTA */}
      <section className="text-center p-4 bg-light rounded-3 mb-5">
        <div className="mb-3">
          <FaUsers size={48} style={{color:"#0096c7"}} />
        </div>
        <h2 className="h3 mb-3">Join Our Growing Community</h2>
        <p className="text-muted mb-4">
          Thousands of students and educators are already transforming their learning and teaching experience on <strong className="text-dark">My Exam World</strong>.
        </p>
    
      </section>

      {/* Stats */}
      <section className="row g-4 text-center mb-5">
        <StatItem number="10+" label="Languages Supported" icon={<FaGlobe size={24} className="text-info" />} />
        <StatItem number="1000+" label="Active Users" icon={<FaUsers size={24} className="text-primary" />} />
        <StatItem number="500+" label="Exams Created" icon={<FaChalkboardTeacher size={24} className="text-success" />} />
        <StatItem number="24/7" label="Support" icon={<MdGroupWork size={24} className="text-warning" />} />
      </section>
    </div>
  );
};

// Reusable Feature Item Component
const FeatureItem = ({ icon, text }) => (
  <li className="list-group-item border-0 px-0 py-2 d-flex align-items-center">
    <span className="me-3">{icon}</span>
    {text}
  </li>
);

// Reusable Stat Item Component
const StatItem = ({ number, label, icon }) => (
  <div className="col-md-3 col-6">
    <div className="p-3 border rounded-3 h-100">
      <div className="mb-2">{icon}</div>
      <h3 className="h2 mb-1">{number}</h3>
      <p className="text-muted mb-0 small">{label}</p>
    </div>
  </div>
);

export default AboutUs;